<script setup>
import {ref, onBeforeMount, onUpdated} from "vue"
import {activitySignOrderStateEnum} from "@/enum/activitySignOrderStateEnum.js";
const props = defineProps({
  state: {
    required: true,
    type: String,
    default: "UNRELEASED"
  }
})
// 展示的文本类型
const textType = ref("info")
// 状态名称
const stateName = ref("未知状态")
// 活动报名状态枚举
const activityState = activitySignOrderStateEnum

// 执行判断
onBeforeMount(() => {
  handleEnum()
})
onUpdated(() => {
  handleEnum()
})

// 根据枚举返回状态
const handleEnum = () => {
  try {
    const enumList = activityState.find(res => res.stateId === props.state)
    console.log("enumList", enumList)
    stateName.value = enumList?.stateName ? enumList.stateName : "未知状态"
    switch (props.state) {
      case "UNPAID":
        textType.value = "danger"
        break
      case "REGISTERED":
        textType.value = "success"
        break
      case "REFUNDING":
        textType.value = "danger"
        break
      case "REFUNDED":
        textType.value = "warning"
        break
      case "COMPLETED":
        textType.value = "primary"
        break
    }
  } catch (e) {
    console.log(e)
  }
}
</script>

<template>
  <el-text :type="textType" v-text="stateName"></el-text>
</template>

<style scoped>

</style>
